module.exports = __webpack_public_path__ + "src/assets/images/volums/wind_speed/volum_circle6.png?9cd6b44b4c66330e159d2413b0c429a2";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/volums/wind_speed/volum_circle6.png
// module id = 829
// module chunks = 0